import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { defaultEditFormState } from "../constant";
import { MembershipAPI } from "../../api/membership";
import VisibilityIcon from "../../assets/SVGs/Login/VisibilityIcon";
import { IconButton, Stack, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditVisitorModal from "../Modal/EditVisitorModal";
import dayjs from "dayjs";

const VisitorTab = ({ id }) => {
  const navigate = useNavigate();
  const isMobileTable = useMediaQuery("(max-width:850px)");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(defaultEditFormState);

  const fetch = async () => {
    setIsLoading(true);
    try {
      setData(await MembershipAPI.getVisitor(id));
    } catch (e) {
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
      console.error("Error during fetching report", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    isLoading && fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, isLoading]);

  const columns = [
    {
      field: "visitor_first_name",
      headerName: "First Name",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
    },
    {
      field: "visitor_last_name",
      headerName: "Last Name",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
    },
    {
      field: "phone_number",
      headerName: "Phone Number",
      flex: 1,
      minWidth: isMobileTable ? 180 : undefined,
    },
    {
      field: "email_address",
      headerName: "Email Address",
      flex: 1,
      minWidth: isMobileTable ? 200 : undefined,
    },
    {
      field: "date_visited",
      headerName: "Date Visited",
      flex: 1,
      minWidth: isMobileTable ? 170 : undefined,
      type: "date",
      valueGetter: (params) => {
        return dayjs(params).toDate(); // returns a native JS Date
      },
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("MM/DD/YYYY") : "";
      },
    },
    {
      field: "chair",
      headerName: "Chair",
      flex: 1,
      minWidth: isMobileTable ? 200 : undefined,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="view"
          size="small"
          onClick={() =>
            setOpenEditModal({
              open: true,
              id: params?.row?.id,
              title: `${params.row?.visitor_first_name} ${params?.row?.visitor_last_name} Visitor`,
            })
          }
        >
          <VisibilityIcon
            sx={{
              color: "#64748B",
            }}
          />
        </IconButton>
      ),
    },
  ];
  return (
    <>
      <div className="sub-header">Visitors brought by Member</div>
      <Stack
        sx={{
          width: "100%",
          "& .MuiDataGrid-root": {
            borderRadius: "8px",
          },
        }}
        className="customDataGridFigma"
      >
        <DataGrid
          rows={data?.items || []}
          columns={columns}
          loading={isLoading}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          checkboxSelection={false}
          rowSelection={false}
          rowHeight={48}
          columnHeaderHeight={40}
          getRowClassName={(params) => {
            const customClassName =
              params.indexRelativeToCurrentPage % 2 !== 0 ? "bg-gray" : "";
            return ` ${customClassName}`.trim();
          }}
          slotProps={{
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "linear-progress",
            },
          }}
          localeText={{
            noRowsLabel: "No visitor found.",
          }}
          disableVirtualization
        />
        {openEditModal?.open && (
          <EditVisitorModal
            open={openEditModal?.open}
            id={openEditModal?.id}
            handleClose={() => setOpenEditModal(defaultEditFormState)}
            setIsLoading={setIsLoading}
            title={openEditModal?.title}
          />
        )}
      </Stack>
    </>
  );
};

export default VisitorTab;
